import { Component, Input, OnInit } from '@angular/core';
import { ShopCartService } from "./shop.cart.service";
import { OptionService } from "../option/option.service";
import { ShopCartItem } from './shop.cart.item';
import { Donation } from 'donation/donation';
import { Product } from './shop.product.model';
import { PRODUCT_ID_OPTIONAL_DONATION } from './shop.config';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'shop-cart-summary',
    templateUrl: './shop.cart.summary.component.html',
})

export class ShopCartSummaryComponent implements OnInit {
    /**
     * The donation object.
     */
    @Input() donation: Donation;

    /**
     * The form group.
     */
    @Input() form: FormGroup;

    /**
     * The current step
     */
    @Input() step: string;

    /**
     * The items in the cart.
     */
    items: ShopCartItem[] = [];

    /**
     * The items in the cart without the optional donation.
     */
    itemsWithoutOptionalDonation: ShopCartItem[] = [];

    /**
     * The total price of the cart without the optional donation.
     */
    totalPrice: number = null;

    /**
     * The price of the optional donation.
     */
    optionalDonationPrice: number = null;

    /**
     * Policy content and toggle
     */
    policyContent: string = null;
    hasPolicy = false;

    /**
     * Terms content and toggle
     */
    termsContent: string = null;
    hasTerms = false;

    /**
     * Flag if the shop summary is available
     */
    hasShopSummary: boolean = false;

    /**
     * The gift count.
     */
    giftCount: number = 0;

    /**
     *
     * @param cartService
     * @param optionService
     */
    constructor(private cartService: ShopCartService, private optionService: OptionService) { }

    /**
     * Initializes the component.
     */
    ngOnInit(): void {
        this.hasShopSummary = this.optionService.getOption("has_shop_summary");
        if (!this.hasShopSummary) {
            return;
        }

        // get the items from the cart
        this.items = this.cartService.getItems();
        this.itemsWithoutOptionalDonation = this.items.filter(item => item.product.id !== PRODUCT_ID_OPTIONAL_DONATION);

        // get the optional donation product and price
        const optionalProduct = this.items.find(item => item.product.id === PRODUCT_ID_OPTIONAL_DONATION);
        if (optionalProduct) {
            this.optionalDonationPrice = optionalProduct.getPrice();
        }

        // get the gift count
        this.giftCount = this.cartService.getGiftCount();

        // calculate the total price
        this.totalPrice = this.cartService.getItemsPrice() - this.optionalDonationPrice;

        // get the policy and terms text
        this.hasPolicy = this.optionService.getOption('has_shop_policy');

        this.hasTerms = this.optionService.getOption('has_shop_terms');
        if (this.hasTerms) {
            // add validation for the terms checkbox
            this.form.addControl('summary_terms', new FormControl('', [Validators.required, Validators.pattern('true')]));
        }
    }

    /**
      * returns the path to the product image.
      * @param product
      */
    getProuctImage(product: Product): string {
        if (product.images.length > 0) {
            return this.optionService.getImageDirectory() + '/' + product.images[0].file;
        }
        return null;
    }
}
